<template>
    <MyAccount></MyAccount>
</template>

<script>
    import MyAccount from "../components/MyAccount";

    export default {
        name: "my-account",
        components: {
            MyAccount,
        }
    };
</script>